import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Badge, Button, Card, ListGroup, Spinner } from 'react-bootstrap';
import API from '../services/api';

const formatWhen = (val) => {
  if (!val) return '';
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleString('en-IN', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
};

const AdminNotifications = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [marking, setMarking] = useState(false);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setError('');
    try {
      const { data } = await API.get('/admin/notifications');
      setRows(Array.isArray(data) ? data : []);
    } catch (_err) {
      setError('Unable to load notifications right now.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const markAllSeen = async () => {
    setMarking(true);
    try {
      await API.patch('/admin/notifications/mark-all-seen');
      setRows((prev) => prev.map((n) => ({ ...n, seen: true })));
    } catch (_err) {
      setError('Failed to mark notifications as read.');
    } finally {
      setMarking(false);
    }
  };

  const unread = rows.filter((n) => !n.seen).length;

  return (
    <div>
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <div className="fw-semibold">Admin Notifications</div>
          <div className="d-flex align-items-center gap-2">
            {unread > 0 && <Badge bg="danger">{unread} unread</Badge>}
            <Button
              size="sm"
              variant="outline-primary"
              onClick={markAllSeen}
              disabled={marking || unread === 0}
            >
              {marking ? 'Marking...' : 'Mark all read'}
            </Button>
          </div>
        </Card.Header>

        {error && <Alert variant="danger" className="m-3 mb-0">{error}</Alert>}

        {loading ? (
          <div className="p-4 text-center text-muted">
            <Spinner size="sm" className="me-2" /> Loading notifications...
          </div>
        ) : (
          <ListGroup variant="flush">
            {rows.length ? (
              rows.map((n) => (
                <ListGroup.Item key={n._id} className="d-flex justify-content-between align-items-start gap-3">
                  <div>
                    <div className="fw-semibold">{n.message || 'Notification'}</div>
                    <div className="small text-muted">{formatWhen(n.createdAt)}</div>
                  </div>
                  {!n.seen && <Badge bg="warning" text="dark">New</Badge>}
                </ListGroup.Item>
              ))
            ) : (
              <ListGroup.Item className="text-muted">No notifications yet.</ListGroup.Item>
            )}
          </ListGroup>
        )}
      </Card>
    </div>
  );
};

export default AdminNotifications;
